export const isPresetDashboard = () => {
  const subPaths = window.location.pathname.split('/');
  return String(subPaths[subPaths.length - 2]).toLocaleLowerCase() === 'preset';
};

export const isSharingDashboard = () => {
  const subPaths = window.location.pathname.split('/');
  return String(subPaths[subPaths.length - 2]).toLocaleLowerCase() === 'sharing';
};

export const isDrillDownDashboard = () => {
  const subPaths = window.location.pathname.split('/');
  const path = String(subPaths[subPaths.length - 2]).toLocaleLowerCase();
  return path === 'drilldown' || path === 'cd-drilldown';
};

export const isRtDrillDownDashboard = () => {
  const subPaths = window.location.pathname.split('/');
  const path = String(subPaths[subPaths.length - 2]).toLocaleLowerCase();
  return path === 'rt-drilldown';
};

export const isAiAlertsDiagnosticsDashboard = () => {
  return /\/ai-alerts\/diagnostics(\/|$)/i.test(window.location.pathname);
};

export const isUserTimelineDashboard = () =>
  /\/dashboard\/user-timeline(\/|$)/i.test(window.location.pathname);

export const isSavedDashboard = () => {
  const subPaths = window.location.pathname.split('/');
  return String(subPaths[subPaths.length - 2]).toLocaleLowerCase() === 'saved';
};

const getIdFromUrl = () => {
  const subPaths = window.location.pathname.split('/');
  return subPaths[subPaths.length - 1] ?? '';
};

export const getPresetKeyFromUrl = () => {
  if (isPresetDashboard()) {
    return getIdFromUrl();
  }
  return '';
};

export const getSavedDashboardIdFromUrl = () => {
  if (isSavedDashboard()) {
    return getIdFromUrl();
  }
  return '';
};

export const getSharingIdFromUrl = () => {
  if (isSharingDashboard()) {
    return getIdFromUrl();
  }
  return '';
};

export const APP_FLOW_PRESET_ROUTE_PATH_REGEX = /\/dashboard\/preset\/flow\/(\d+)$/;
export const APP_FRUSTRATION_SIGNAL_PRESET_ROUTE_PATH_REGEX =
  /\/dashboard\/preset\/frustration-signal\/([\w-]+)$/;
export const APP_EVENT_PRESET_ROUTE_PATH_REGEX = /\/dashboard\/preset\/event\/([^/]+)$/;

export const isAppFlowPresetDashboard = () =>
  APP_FLOW_PRESET_ROUTE_PATH_REGEX.test(window.location.pathname);

export const isAppFrustrationSignalPresetDashboard = () =>
  APP_FRUSTRATION_SIGNAL_PRESET_ROUTE_PATH_REGEX.test(window.location.pathname);

export const isAppEventPresetDashboard = () =>
  APP_EVENT_PRESET_ROUTE_PATH_REGEX.test(window.location.pathname);

export const isAppFlowPresetUsecaseKey = (usecaseKey?: string) => !!usecaseKey?.startsWith('flow:');

export const getAppFlowUsecaseKeyFromFlowId = (id: string | number) => `flow:${id}`;

export const getAppFlowUsecaseKeyFromUrl = () => {
  const matchAppFlowPreset = window.location.pathname.match(APP_FLOW_PRESET_ROUTE_PATH_REGEX);
  if (matchAppFlowPreset) {
    return getAppFlowUsecaseKeyFromFlowId(matchAppFlowPreset[1]);
  }
  return '';
};

export const getAppFlowIdFromUsecaseKey = (usecaseKey?: string) =>
  usecaseKey?.startsWith('flow:') ? usecaseKey.slice(5) : undefined;

export const isAppFrustrationSignalPresetUsecaseKey = (usecaseKey?: string) =>
  !!usecaseKey?.startsWith('frustration-signal:');

export const getAppFrustrationSignalUsecaseKeyFromSignalId = (id: string | number) =>
  `frustration-signal:${id}`;

export const getAppFrustrationSignalUsecaseKeyFromUrl = () => {
  const matchAppFrustrationSignalPreset = window.location.pathname.match(
    APP_FRUSTRATION_SIGNAL_PRESET_ROUTE_PATH_REGEX,
  );
  if (matchAppFrustrationSignalPreset) {
    return getAppFrustrationSignalUsecaseKeyFromSignalId(matchAppFrustrationSignalPreset[1]);
  }

  return '';
};

export const getAppFrustrationSignalIdFromUsecaseKey = (usecaseKey?: string) =>
  usecaseKey?.startsWith('frustration-signal:') ? usecaseKey.slice(19) : undefined;

export const isAppEventPresetUsecaseKey = (usecaseKey?: string) =>
  !!usecaseKey?.startsWith('event:');

export const getAppEventUsecaseKeyFromEventId = (id: string | number) => `event:${id}`;

export const getAppEventUsecaseKeyFromUrl = () => {
  const matchAppEventPreset = window.location.pathname.match(APP_EVENT_PRESET_ROUTE_PATH_REGEX);
  if (matchAppEventPreset) {
    return getAppEventUsecaseKeyFromEventId(matchAppEventPreset[1]);
  }

  return '';
};

export const getAppEventIdFromUsecaseKey = (usecaseKey?: string) => {
  if (!usecaseKey?.startsWith('event:')) return undefined;
  const eventId = usecaseKey.slice(6);
  // Decode URL-encoded event IDs (e.g., "app%20crash" -> "app crash")
  try {
    return decodeURIComponent(eventId);
  } catch (e) {
    // If decoding fails, return as-is
    return eventId;
  }
};
